<template>
  <div class="scd">
    <c_Nav :Index="Index" :city-code="cityCode"></c_Nav>
    <c_NewMessage></c_NewMessage>
    <!--内容  star-->
    <div class="scdMain">
      <div class="secondMainTitle">
        <i></i>
        <span>服务范围</span>
      </div>
      <div class="scdMainText" v-html="list.NewsContent"></div>
    </div>
    <!--内容  end-->

  </div>
</template>

<script>
  import c_Nav from '@/components/Nav/Nav'
  import c_NewMessage from '@/components/NewMessage/NewMessage'
  export default {
    name: '',
    props:['cityCode'],
    components:{c_Nav,c_NewMessage},
    data () {
      return {
        Index:3,
        list:{}
      }
    },
    mounted() {
      this.getCaseData();
    },
    methods:{
      getCaseData:function () {
        var that = this;
        this.axios.get('NewsList',{
          params:{newsType:'4'}
        }).then(function (res) {
          console.log(res);
          that.list = res.data.data.list[0];
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  }
</script>

<style>
  .scdMainText img{max-width: 100%;}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .clear {overflow: hidden;}
  .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

  .scdMain{width: 702px;margin: 0 auto 20px;}

  /*标题  star*/
  .secondMainTitle{height: 90px;border-bottom: 2px dashed #9fb0c0;text-align: left}
  .secondMainTitle i{width: 8px;height: 36px;background: #1dd2af;display: inline-block;text-align: left;margin-top: 44px;}
  .secondMainTitle span{height:44px;font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(44,62,80,1);margin: 0 0 0 14px;display:inline-block}
  /*标题  end*/

  .scdMainText{padding-top: 40px;box-sizing: border-box}

</style>



// WEBPACK FOOTER //
// src/components/ScopeService/ScopeService.vue